import script from "./SfxTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTd from 'quasar/src/components/table/QTd.js';import TouchHold from 'quasar/src/directives/touch-hold/TouchHold.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QSeparator,QTable,QCheckbox,QTd});qInstall(script, 'directives', {TouchHold});
